module.exports = __webpack_public_path__ + "img/class-banner1.556dde4.webp";